module.exports = __webpack_public_path__ + "static/media/absurd_history_podcast_1200x628.b57662f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/absurd_history_podcast_1200x628.jpg
// module id = 596
// module chunks = 0